<template>
  <div class="community-feed">
    <div v-if="loadingInitial" class="text-center py-4">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <div v-if="!posts.length" class="empty text-center py-5">
        Ainda não há publicações nesta comunidade.
      </div>

      <post-card
        v-for="post in posts"
        :key="post.id"
        :post="post"
        :can-moderate="canModerate"
        class="mb-3"
        @updated="onPostUpdated"
        @deleted="onPostDeleted"
      />

      <div v-if="hasMore" class="text-center mt-3">
        <button
          class="btn btn-outline-primary"
          :disabled="loadingMore"
          @click="loadMore"
        >
          <loading :show="loadingMore" small>Carregar mais</loading>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import PostCard from "./PostCard.vue";

const LIMIT = 10;

export default {
  name: "CommunityFeed",
  components: { PostCard },
  props: {
    communityId: {
      type: String,
      required: true
    },
    canModerate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      posts: [],
      count: 0,
      offset: 0,
      loadingInitial: true,
      loadingMore: false
    };
  },
  computed: {
    hasMore() {
      return this.posts.length < this.count;
    }
  },
  mounted() {
    this.reload();
  },
  methods: {
    fetch() {
      return this.$store.dispatch("community/listPosts", {
        id: this.communityId,
        limit: LIMIT,
        offset: this.offset
      });
    },
    reload() {
      this.offset = 0;
      this.loadingInitial = true;
      this.fetch()
        .then(data => {
          this.count = data.count;
          this.posts = data.results;
        })
        .finally(() => {
          this.loadingInitial = false;
        });
    },
    loadMore() {
      this.offset += LIMIT;
      this.loadingMore = true;
      this.fetch()
        .then(data => {
          this.count = data.count;
          this.posts = [...this.posts, ...data.results];
        })
        .finally(() => {
          this.loadingMore = false;
        });
    },
    onPostUpdated(updated) {
      const index = this.posts.findIndex(post => post.id === updated.id);
      if (index !== -1) this.$set(this.posts, index, updated);
    },
    onPostDeleted(id) {
      this.posts = this.posts.filter(post => post.id !== id);
    }
  }
};
</script>

<style lang="scss" scoped>
.community-feed {
  .empty {
    opacity: 0.7;
  }
}
</style>
